module.exports = __webpack_public_path__ + "static/media/caret_up_filled.322ba1e7.svg";